import {
  Wrapper,
  CategoryRow,
  CategoryName,
} from "./SurgeryCategoriesName.styled";
import { getCardType, getCardValue } from "utils/tabUtils";

export const SurgeryCategoriesNames = ({ item }: { item: any }) => {
  const getCategories = (item: any) => {
    const categories: any = [];
    const { category, treatmentItems } = item;
    if (category === "NONE") {
      const cardType = getCardType(item);
      const cardValue = getCardValue(item);
      switch (cardType) {
        case "SURGERY":
        case "SKINCARE":
        case "PAYMENT":
          {
            cardValue.map((card: any) => {
              if ((card.items || []).length > 0) {
                card.items.forEach((v: any) => {
                  categories.push({
                    categoryName: v.categoryName,
                    name: v.name,
                    count: v.count,
                  });
                });
              }
            });
          }
          break;
      }
    } else {
      //예약 or 접수
      if (treatmentItems?.length > 0) {
        treatmentItems.forEach((v: any) => {
          categories.push({
            categoryName: v.categoryName,
            name: v.name,
          });
        });
      }
    }

    return categories;
  };

  const categories = getCategories(item);

  return categories.map((v: any, i: number) => {
    return (
      <Wrapper key={i}>
        <CategoryRow>
          {v.categoryName && (
            <>
              <CategoryName>{v.categoryName}</CategoryName>
              <span>&nbsp;-&nbsp;</span>
            </>
          )}
          <CategoryName>{v.name}</CategoryName>
        </CategoryRow>
        {v.count && <div className="count-wrapper">{v.count}</div>}
      </Wrapper>
    );
  });
};
